<div
  class="filter-menu-container"
  cdkDropList
  (cdkDropListDropped)="drop($event)"
>
  @for (col of data.displayColumns; track col) {
    <div
      matMenuItem
      cdkDrag
      class="filter-menu-item"
      (click)="$event.stopPropagation()"
    >
      <div *cdkDragPlaceholder></div>
      <mat-checkbox class="filter-menu-item-checkbox" [(ngModel)]="col.visible">
        {{ col.displayLabel | uppercase }}
      </mat-checkbox>
      <mat-icon cdkDragHandle class="filter-menu-item-drag-handle"
      >drag_indicator
      </mat-icon
      >
    </div>
  }
</div>
